import React from 'react'

import { RatingsHistory } from './RatingsHistory'
import { RatedEntityCell } from './RatedEntityCell'
import { onButtonTriggerKey } from '../../utils'

type Props = {
  handleClick: (rowIndex: number, ratableId: string) => void
  isUspf?: boolean
  row: any
  ratablesRatingHistory?: any
}

type State = {
  isOpen: boolean
}

class RatingsHistoryPopup extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)
    this.state = {
      isOpen: true
    }
  }

  handleOverlayClick() {
    const { handleClick, row } = this.props
    handleClick(row.index, row.id)
    this.setState({ isOpen: false })
  }

  render() {
    const { handleClick, isUspf, row, ratablesRatingHistory } = this.props
    const { isOpen } = this.state
    return isOpen ? (
      <div
        className="frw-ratings-history-overlay"
        onClick={this.handleOverlayClick}
        onKeyDown={onButtonTriggerKey(this.handleOverlayClick)}
        role="presentation"
      >
        <div
          className="frw-ratings-history-popup"
          onClick={(event: any) => event.stopPropagation()}
          role="presentation"
        >
          <span
            onClick={() => handleClick(row.index, row.id)}
            onKeyDown={onButtonTriggerKey(() => handleClick(row.index, row.id))}
            tabIndex={0}
            role="button"
          >
            <i className="fas fa-times" />
          </span>
          <div className="frw-ratables-ratings-history-container">
            <RatingsHistory ratablesRatingHistory={ratablesRatingHistory}>
              <RatedEntityCell isUspf={isUspf} cellProps={row} />
            </RatingsHistory>
          </div>
        </div>
      </div>
    ) : null
  }
}

export default RatingsHistoryPopup
